export default __webpack_public_path__ + "static/media/NavbarServeX.eeeb8ef5.svg";